import { useState } from 'react'
import {
  useTranslate,
  useRecordContext,
  Toolbar,
  SaveButton,
  FormDataConsumer,
} from 'react-admin'
import { Button as ButtonM, Grid, Box } from '@material-ui/core'

const PvToolbar = ({
  agId,
  save,
  record: ParentRecord,
  label,
  presidentSelectValue,
  presidentInputValue,
  secretarySelectValue,
  secretaryInputValue,
  validateEmail,
  loadingFile,
  getPvPreview,
}) => {
  const record = ParentRecord || useRecordContext()
  const [isSending, setIsSending] = useState(false)

  const translate = useTranslate()

  return (
    <Toolbar>
      <Grid container spacing={2}>
        {agId && (
          <>
            <Grid item>
              <ButtonM
                disabled={isSending || loadingFile}
                color="secondary"
                variant="contained"
                onClick={getPvPreview}
              >
                {loadingFile ? 'Chargement...' : translate('hs.ags.preview_pv')}
              </ButtonM>
            </Grid>
            <Grid item>
              <ButtonM
                disabled={isSending}
                color="secondary"
                variant="contained"
                target="_blank"
                href={`${window.location.origin}/pvagsfeuillepresence/${agId}/show`}
              >
                {translate('hs.ags.attendance_sheet')}
              </ButtonM>
            </Grid>
          </>
        )}
        <Grid item>
          <FormDataConsumer>
            {({ formData }) => (
              <Box>
                <SaveButton
                  disabled={
                    isSending ||
                    !formData.datereelle ||
                    !formData.end_datetime ||
                    (!presidentSelectValue &&
                      !validateEmail(presidentInputValue)) ||
                    (!secretarySelectValue &&
                      !validateEmail(secretaryInputValue))
                  }
                  label={label || 'Envoyer'}
                  onClick={() => {
                    setIsSending(true)
                    save({ record, formData, setIsSending })
                  }}
                />
                {!formData.datereelle || !formData.end_datetime ? (
                  <p
                    style={{
                      display: 'inline',
                      background: '#fdd8d8',
                      fontSize: '12px',
                      marginLeft: '10px',
                      padding: '10px',
                      color: 'red',
                    }}
                  >
                    La date de tenue et ou date de fin de l’AG ne sont pas
                    renseignés (onglet Admin)
                  </p>
                ) : null}
              </Box>
            )}
          </FormDataConsumer>
        </Grid>
      </Grid>
    </Toolbar>
  )
}

export default PvToolbar
